export default async function mswStarterLogic() {
	if (typeof window === 'undefined') return;

	const isDev =
		import.meta.env.MODE === 'development' ||
		process.env.NODE_ENV === 'development' ||
		window.location.hostname === 'localhost';

	if (!isDev) return;

	if (window.location.pathname === '/public') {
		window.location.pathname = '/public/';
		return;
	}

	const { worker } = await import('../mocks/browser');
	await worker.start({
		serviceWorker: {
			url: '/mockServiceWorker.js',
		},
		onUnhandledRequest(req) {
			// Bypass Boost.ai requests so they can go through Vite proxy
			const url = new URL(req.url);
			if (
				url.hostname === 'ashsandbox.boost.ai' ||
				url.pathname.includes('/api/chat_panel') ||
				url.pathname.includes('/api/chat') ||
				url.pathname.includes('/chatPanel')
			) {
				return 'bypass';
			}
			// Default behavior for other unhandled requests
			return 'warn';
		},
	});
}
